import randomString from 'random-string';
import sha from 'sha.js';
import { subtle, base64urlFromString, bufferFromString, stringFromBuffer } from '@rambler-id/crypto';
export const importSecret = () => {
    if (typeof window === 'undefined' || !subtle) {
        return;
    }
    try {
        const secretString = window.sessionStorage.getItem('rpcsecret');
        if (secretString) {
            const [kid, keyString] = secretString.split(':');
            return {
                kid,
                keyString
            };
        }
    }
    catch (error) { }
};
let secretKey;
export const signPayload = async (kid, keyString, body) => {
    const header = {
        kid,
        alg: 'RS256'
    };
    const payload = {
        host: 'id.rambler.ru',
        uri: '/jsonrpc',
        method: 'POST',
        ctime: Math.floor(Date.now() / 1000),
        nonce: randomString(),
        body_sha256: sha('sha256').update(body).digest('hex')
    };
    const encodedHeader = base64urlFromString(JSON.stringify(header));
    const encodedPayload = base64urlFromString(JSON.stringify(payload));
    const securedInputToSign = `${encodedHeader}.${encodedPayload}`;
    if (!secretKey) {
        const keyData = bufferFromString(window.atob(keyString));
        const algo = {
            name: 'RSASSA-PKCS1-v1_5',
            hash: { name: 'SHA-256' }
        };
        secretKey = await subtle.importKey('pkcs8', keyData, algo, false, ['sign']);
    }
    const signature = await subtle.sign('RSASSA-PKCS1-v1_5', secretKey, bufferFromString(securedInputToSign));
    return `${securedInputToSign}.${base64urlFromString(stringFromBuffer(signature))}`;
};
